import { formatDressCareValue } from './dressCare';

export const CARE_FIELDS = [
  'care_washing',
  'care_ironing',
  'care_bleaching',
  'care_dry_cleaning',
  'care_drying'
];

/** All care enum keys that have a corresponding SVG in public/care-symbols/ */
export const CARE_SYMBOL_KEYS = [
  'not_allowed_machine',
  'machine_30',
  'machine_40',
  'machine_60',
  'machine_90',
  'bleach_allowed',
  'bleach_not_allowed',
  'tumble_not_allowed',
  'tumble_high_max',
  'tumble_low_regular',
  'tumble_medium_regular',
  'tumble_high_regular',
  'iron_not_allowed',
  'iron_low_110',
  'iron_medium_150',
  'iron_high_200',
  'dry_clean_not_allowed',
  'dry_clean_any_except_trichloroethylene'
];

const PUBLIC_URL = process.env.PUBLIC_URL || '';

export function getCareSymbolAssetUrl(enumKey) {
  if (!enumKey) return '';
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}${PUBLIC_URL}/care-symbols/${enumKey}.svg`;
}

export function getCareSymbolHtml(fieldName, enumKey) {
  if (!enumKey) return '';
  const url = getCareSymbolAssetUrl(enumKey);
  if (!url) return '';
  return `<span class="care-symbol"><img src="${url}" alt="" width="26" height="26" /></span>`;
}

/** JSX-friendly counterpart to buildCareSymbolsRow: returns structured items instead of an HTML string. */
export function getCareSymbolItems(dress, { t } = {}) {
  return CARE_FIELDS.map((field) => {
    const value = dress?.[field];
    if (!value) return null;
    return {
      field,
      value,
      iconUrl: getCareSymbolAssetUrl(value),
      label: t ? formatDressCareValue(t, field, value) : value
    };
  }).filter(Boolean);
}

export function buildCareSymbolsRow(dress, { labels = false, t } = {}) {
  const items = CARE_FIELDS.map((field) => {
    const value = dress?.[field];
    if (!value) return '';
    const icon = getCareSymbolHtml(field, value);
    if (!labels) return icon;
    const label = t ? formatDressCareValue(t, field, value) : value;
    return `<div class="care-symbol-item">${icon}<span class="care-symbol-label">${label}</span></div>`;
  }).filter(Boolean);

  if (items.length === 0) return '';
  return `<div class="care-symbols-block">${items.join('')}</div>`;
}

export const CARE_SYMBOLS_PRINT_CSS = `
  .care-symbols-block {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin: 4px 0;
  }
  .care-symbol-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .care-symbol {
    display: inline-block;
    width: 26px;
    height: 26px;
    vertical-align: middle;
    flex-shrink: 0;
  }
  .care-symbol img {
    width: 26px;
    height: 26px;
    display: block;
  }
  .care-symbol-label {
    font-size: 11px;
    line-height: 1.3;
    max-width: 180px;
  }
`;
